<template>
  <div class="hero bg-base-200 my-20">
    <div class="hero-content text-center flex-col w-full px-4">
      
      <div class="max-w-2xl text-center mb-8">
        <h1 class="text-5xl font-bold">Find Your Next Great Meal</h1>
        <p class="py-6 text-lg">Discover the best restaurants, cafes, and eateries around you.</p>
      </div>
      
      <div class="card w-full max-w-4xl shadow-2xl bg-base-100">
        <div class="card-body p-4 md:p-8">
          <form class="flex flex-col md:flex-row gap-4 w-full" @submit.prevent="handleSearch">
            <input 
              v-model="searchQuery" 
              type="text"
              placeholder="Search for restaurants, categories, or dishes..." 
              class="input input-bordered w-full text-lg h-16" 
            >
            <button 
              type="submit" 
              class="btn btn-primary w-full md:w-auto h-16 px-10 text-lg"
            >
              Search
            </button>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const searchQuery = ref('')

const handleSearch = () => {
  // Emit or route to search results page
  console.log('Searching for:', searchQuery.value)
}
</script>